module.exports = __webpack_public_path__ + "img/card2.7635b6e1.png";